// @givmo/app-admin — the passkey sign-in DARK GATE, bound to this portal's auth context (AS-WEB2).
//
// The gate itself — the probe, its per-page-load memo, and the per-tab `sessionStorage` verdict with
// its asymmetric TTLs, sized against the backend's per-IP assertion limiter — lives in
// `@givmo/passkeys` (`usePasskeySignInAvailability`), lifted there by AS-WEB12 so the charity
// console's director door shares it; read its header before changing when this button appears. This
// file binds it to `useAuth()`'s probe and keeps the names this portal's screens and tests use.

import { usePasskeySignInAvailability } from '@givmo/passkeys';
import { useAuth } from '../../auth/auth-context';

/**
 * Drop the memoised probe, and by default the stored verdict too — a TEST SEAM (see
 * `resetPasskeySignInAvailabilityProbe`; `keepStoredVerdict: true` is a reload).
 */
export { resetPasskeySignInAvailabilityProbe as resetPasskeyAvailabilityProbe } from '@givmo/passkeys';

/**
 * Whether the passkey sign-in affordance should render: the browser can run a WebAuthn ceremony AND
 * the backend serves the assertion routes. Starts `false` and only ever flips to `true`.
 */
export function usePasskeyAvailability(): boolean {
  const { probePasskeyAvailability } = useAuth();
  return usePasskeySignInAvailability(probePasskeyAvailability);
}
